import { http, passthrough } from "msw";
export const auditLogsHandlers = [
    // Passthrough to real backend for entropy logs
    http.get("*/api/v1/entropy/logs", ()=>{
        return passthrough();
    })
];
export default auditLogsHandlers;
